export const DEFAULT_SEARCH_RADIUS_METERS = 1600
export const MIN_SEARCH_DIAMETER_METERS = 800
export const MAX_SEARCH_DIAMETER_METERS = 4800
export const SEARCH_DIAMETER_STEP_METERS = 200

export const getValuationSearchRadius = (valuation) => {
  if (Number.isFinite(valuation?.searchRadiusMeters)) return valuation.searchRadiusMeters
  const acceptedStep = [...(valuation?.ladderData || [])].reverse().find((step) => !step.skipped && Number.isFinite(step.radius))
  return acceptedStep?.radius || DEFAULT_SEARCH_RADIUS_METERS
}

export const getValuationUsedSearchRadius = (valuation) => {
  if (Number.isFinite(valuation?.usedSearchRadiusMeters)) return valuation.usedSearchRadiusMeters
  const acceptedStep = [...(valuation?.ladderData || [])].reverse().find((step) => !step.skipped && Number.isFinite(step.radius))
  return acceptedStep?.radius || getValuationSearchRadius(valuation)
}
